import { Storage } from '@shared/constants/Storage'

import { CurrentUserDTO } from '../types/Users/users'

export function useCurrentUser(): CurrentUserDTO {
  return JSON.parse(localStorage.getItem(Storage.CURRENT_PROFILE) || '{}') as CurrentUserDTO
}
